// System directives

'use client';

// System dependencies

import React from 'react';
import { useTheme } from 'next-themes';

// Application dependencies

import { cn } from '@/lib/utils';

// Styling

import { BiSun, BiSolidSun } from 'react-icons/bi';

// Props

interface FormThemeSwitcherProps {
  className?: string;
}

const DEFAULT_ICON_STYLE = 'h-7 w-7 text-primary hover:text-blue-600';

const FormThemeSwitcher: React.FC<FormThemeSwitcherProps> = ({ className }) => {
  // Application state

  const { theme, setTheme } = useTheme();

  // ---------------------------------------------------------------------------------------------------------------------------------------
  // Form interaction and rendering
  // ---------------------------------------------------------------------------------------------------------------------------------------

  const handleOnClick = () => {
    if (theme === 'dark') {
      setTheme('light');
    } else {
      setTheme('dark');
    }
  };

  return (
    <>
      <button onClick={handleOnClick}>{theme === 'dark' ? <BiSun className={cn(DEFAULT_ICON_STYLE, className)} /> : <BiSolidSun className={cn(DEFAULT_ICON_STYLE, className)} />}</button>
    </>
  );
};

export default FormThemeSwitcher;
